import styled from "styled-components";

export const StyledBinDataWrapper = styled.div`
  .tab-body {
    @media screen and (max-width: 992px) {
      padding: 0;
      border: none;
      border-radius: 0;
      box-shadow: none;
    }
  }

  .content-head {
    padding: 20px 0 30px;
    display: grid;
    grid-template-columns: max-content 175px 1fr;
    grid-gap: 20px;
   
   & > :last-child {
    justify-self: end;
    
    button {
     width: 175px;
    }
   }

    @media screen and (max-width: 768px) {
      grid-template-columns: max-content 175px;
      & > :last-child {
       justify-self: start;
      }
    }
   
    @media screen and (max-width: 576px) {
      grid-template-columns: 100%;
    }
  }
 
 .service-exclusion-table {
  &__head, &__row {
   grid-template-columns: repeat(2 ,minmax(0, 1fr)) minmax(220px, 1fr) minmax(0, 1fr);
  }
 }

 .service-exclusion-table-new {
  &__head, &__row {
   grid-template-columns: repeat(2 ,minmax(0, 1fr)) minmax(220px, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  }
 }
`;

export const StyledExclusionSwitch = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;